module.exports = __webpack_public_path__ + "assets/images/team/Ira2.jpg";